<div class="upload-container">
  <h2>Select Survey Files</h2>
  
  <div class="config-row">
    <div class="config-item">
      <label for="tolerance" class="tolerance-label">Tolerance Threshold (In ft):</label>
      <input 
        type="number" 
        id="tolerance" 
        class="tolerance-input" 
        [(ngModel)]="state.toleranceThreshold" 
        placeholder="Enter tolerance threshold"
        step="0.01"
        min="0"
        max="10000">
    </div>

    <!-- <div class="config-item">
      <label class="tolerance-label">Azimuth Reference:</label>
      <div class="radio-group">
        <label class="radio-label">
          <input 
            type="radio" 
            name="azimuthReference" 
            value="true_north"
            [(ngModel)]="azimuthReference"
            [disabled]="isUploading">
          <span>True North</span>
        </label>
        <label class="radio-label">
          <input 
            type="radio" 
            name="azimuthReference" 
            value="grid_north"
            [(ngModel)]="azimuthReference"
            [disabled]="isUploading">
          <span>Grid North</span>
        </label>
      </div>
      <p class="config-hint">Select the reference system used in your survey azimuth data</p>
    </div> -->

  </div>
  
  <div 
    class="drop-zone"
    [class.dragging]="isDragging"
    [class.disabled]="isUploading"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="!isUploading && fileInput.click()">
    
    <div class="drop-zone-content">
      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
        <polyline points="17 8 12 3 7 8"></polyline>
        <line x1="12" y1="3" x2="12" y2="15"></line>
      </svg>
      <p class="drop-zone-title">Drag & Drop Survey files here</p>
      <p class="drop-zone-subtitle">or click to browse</p>
    </div>
    
    <input 
      #fileInput
      type="file" 
      accept=".csv"
      multiple
      [disabled]="isUploading"
      (change)="onFileSelected($event)"
      style="display: none;">
  </div>

  <div class="files-list" *ngIf="state.uploadedFiles.length > 0">
    <div class="files-header">
      <h3>Selected Files ({{ state.uploadedFiles.length }})</h3>
      <button class="btn-secondary" [disabled]="isUploading" (click)="clearAll()">Clear All</button>
    </div>

    <div class="files-scroll-container">
      <div class="file-item" *ngFor="let file of state.uploadedFiles; let i = index" [class.needs-mapping]="file.needsMapping">
        <div class="file-info">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
          </svg>
          <div class="file-details">
            <span class="file-name">{{ file.name }}</span>
            <span class="file-size">{{ formatFileSize(file.size) }}</span>
            <span class="mapping-status" *ngIf="file.needsMapping">⚠️ Needs column mapping</span>
          </div>
        </div>
        <div class="file-actions">
          <button class="btn-map" [disabled]="isUploading" (click)="openMappingDialog(file)">
            {{ file.needsMapping ? 'Map Columns' : 'Re-map' }}
          </button>
          <button class="btn-remove" [disabled]="isUploading" (click)="removeFile(i)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="upload-actions">
      <button class="btn-secondary" [disabled]="isUploading" (click)="openEpsgDialogManually()" title="Review and edit EPSG codes">
        Review EPSG Codes
      </button>
      <button class="btn-primary" [disabled]="isUploading" (click)="uploadFiles()">
        {{ isUploading ? 'Validating...' : 'Validate Files' }}
      </button>
    </div>
  </div>

  <div class="upload-error" *ngIf="state.uploadError">
    {{ state.uploadError }}
  </div>

  <!-- Loading Overlay -->
  <div class="loading-overlay" *ngIf="isUploading">
    <div class="loading-spinner">
      <div class="spinner"></div>
      <p class="loading-text">Validating survey files...</p>
      <p class="loading-subtext">Please wait while we process your files</p>
    </div>
  </div>

  <div class="view-results-section" *ngIf="state.uploadResults.length > 0 && !showResultsDialog">
    <button class="btn-view-results" (click)="openResultsDialog()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10 9 9 9 8 9"></polyline>
      </svg>
      View Results ({{ state.uploadResults.length }} files)
    </button>
  </div>

  <!-- Results Dialog Component -->
  <app-dialog-result 
    [isVisible]="showResultsDialog" 
    [results]="state.uploadResults"
    (close)="closeResultsDialog()"
    (clearAll)="clearAll()">
  </app-dialog-result>

  <!-- Column Mapping Dialog -->
  <div class="dialog-overlay" *ngIf="showMappingDialog" (click)="closeMappingDialog()">
    <div class="dialog-content" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h3>Map CSV Columns</h3>
        <button class="btn-close" (click)="closeMappingDialog()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      
      <div class="dialog-body" *ngIf="currentMappingFile">
        <p class="dialog-description">
          The file <strong>{{ currentMappingFile.name }}</strong> is missing some required columns.
          Please map your CSV columns to the required fields:
        </p>
        
        <div class="mapping-form">
          <div class="mapping-row" *ngFor="let col of requiredColumns">
            <label class="mapping-label">{{ col }}</label>
            <select 
              class="mapping-select" 
              [ngModel]="getColumnMapping(col)"
              (ngModelChange)="setColumnMapping(col, $event)">
              <option value="">-- Select Column --</option>
              <option *ngFor="let header of currentMappingFile.csvHeaders" 
                [value]="header"
                [disabled]="isHeaderUsed(header, col)">
                {{ header }}
              </option>
            </select>
          </div>
        </div>
      </div>
      
      <div class="dialog-footer">
        <button class="btn-secondary" (click)="closeMappingDialog()">Cancel</button>
        <button class="btn-primary" (click)="saveMappingAndClose()">Save Mapping</button>
      </div>
    </div>
  </div>

  <!-- EPSG Confirmation Dialog -->
  <div class="dialog-overlay" *ngIf="showEpsgDialog" (click)="closeEpsgDialog()">
    <div class="dialog-content epsg-dialog" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h3>Confirm EPSG Codes</h3>
        <button class="btn-close" (click)="closeEpsgDialog()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <div class="dialog-body">
        <p class="dialog-description">
          Detected EPSG values are shown below. You can edit any EPSG before validation.
        </p>

        <div class="epsg-list">
          <div class="epsg-row epsg-header">
            <span class="epsg-col-file">Filename</span>
            <span class="epsg-col-api sortable" (click)="sortByApi()" title="Click to sort by API">
              API
              <span class="sort-indicator" *ngIf="apiSortDirection === 'asc'">▲</span>
              <span class="sort-indicator" *ngIf="apiSortDirection === 'desc'">▼</span>
            </span>
            <span class="epsg-col-code">EPSG Code</span>
            <span class="epsg-col-region">Region</span>
            <span class="epsg-col-note">Status</span>
          </div>

          <div class="epsg-row" *ngFor="let file of state.uploadedFiles">
            <span class="epsg-col-file" [title]="file.name">{{ file.name }}</span>
            <span class="epsg-col-api">{{ file.api || '-' }}</span>
            <span class="epsg-col-code">
              <input
                type="number"
                class="epsg-input"
                min="1"
                step="1"
                [(ngModel)]="file.selectedEpsgCode"
                (ngModelChange)="refreshRegionForEditedEpsg(file)"
                [placeholder]="file.detectedEpsgCode ? '' : 'Enter EPSG'">
            </span>
            <span class="epsg-col-region" [title]="file.epsgDescription || ''">
              {{ file.epsgRegion || '-' }}
            </span>
            <span class="epsg-col-note" [class.error-note]="file.epsgError">
              {{ file.epsgError || 'Detected' }}
            </span>
          </div>
        </div>
      </div>

      <div class="dialog-footer">
        <button class="btn-secondary" (click)="closeEpsgDialog()">Cancel</button>
        <button class="btn-primary" (click)="confirmEpsgCodes()">Confirm</button>
      </div>
    </div>
  </div>
</div>
